export default "__VITE_ASSET__B5ig8PsJ__"